import React, { useEffect, useState } from 'react';
import { auth } from '../services/firebaseConfig'; // Adjust the import path as needed
import { Link } from 'react-router-dom';
import pocketLogo from '../assets/images/logo/pocketv_main_logo.png'; // Make sure this path is correct
import '../styles/NavBar.css';

const NavBar = () => {
  const [user, setUser] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    
    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setUser(null);
      setIsMobileMenuOpen(false);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const toggleMobileMenu = () => {
    console.log('Toggling menu:', !isMobileMenuOpen);
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="navbar-logo">
          <img 
            src={pocketLogo} 
            alt="Pocket Videoke" 
            className="logo-image"
            onError={(e) => {
              console.error('Logo failed to load');
              e.target.style.display = 'none';
            }}
          />
        </Link>
      </div>
      <div className={`navbar-links ${isMobileMenuOpen ? 'active' : ''}`}>
        {!user && (
          <Link to="/register" className="nav-link" onClick={toggleMobileMenu}>
            Get Started
          </Link>
        )}
        {user ? (
          <>
            <Link to="/account" className="nav-link" onClick={toggleMobileMenu}>
              Account
            </Link>
            <Link to="/sessions" className="nav-link" onClick={toggleMobileMenu}>
              Sessions
            </Link>
            <Link to="/about" className="nav-link" onClick={toggleMobileMenu}>About</Link>
            <Link to="/contact" className="nav-link" onClick={toggleMobileMenu}>Contact</Link>
            <Link to="/pricing" className="nav-link" onClick={toggleMobileMenu}>Pricing</Link>
            <button onClick={handleLogout} className="nav-link logout-btn">
              Log out
            </button>
          </>
        ) : (
          <Link to="/login" className="nav-link" onClick={toggleMobileMenu}>
            Login
          </Link>
        )}
      </div>
      <button className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>
    </nav>
  );
};

export default NavBar;
